import { ampFetch } from './api';

const loyalty = {
    /**
     * @typedef LoyaltyPointsResponse
     * @property {number} [points_available]
     * @property {number} [points_expiring]
     * @property {number} [points_recently_expired]
     */
    /**
     * @returns {Promise<LoyaltyPointsResponse>}
     */
    getLoyaltyPoints: async () => {
        return await ampFetch({
            route: 'api-user/loyalty/get-loyalty-points',
            options: {
                method: 'POST'
            }
        });
    },
    getRewardTiers: async () => {
        return await ampFetch({
            route: 'api-user/loyalty/get-reward-tiers',
            options: {
                method: 'POST'
            }
        });
    },
    redeem: async (reward_tier_id) => {
        return await ampFetch({
            route: 'api-user/loyalty/redeem',
            options: {
                method: 'POST',
                body: JSON.stringify({
                    reward_tier_id
                })
            }
        });
    },
    getTransactionHistory: async (paging) => {
        return await ampFetch({
            route: 'api-user/loyalty/get-transaction-history',
            options: {
                method: 'POST',
                body: JSON.stringify({ paging })
            }
        });
    }
};

export default loyalty;
